import styled from "@emotion/styled";
import { Heading } from "react-aria-components";

export const StyledCalendarHeading = styled(Heading)`
  flex: 1;
  margin: 0;
  text-align: center;
  font-size: 1rem;
`;
